'use strict';

import posthog from 'posthog-js';

/* global google */

angular.module('lingApp')
  .directive('ripLogin', function ($cookies, $window, $document, i18n, RipServer, RipRoute, RipDialog, RipContext) {
    return {
      template: require('views/rip-login.html'),
      restrict: 'E',
      scope: {},
      link: function postLink(scope, element, attrs) {
        scope.error = {};
        scope.login = { email: $cookies.get('loginEmail'),
                        rememberEmail: !!$cookies.get('loginEmail')
                      };
        scope.autocompleteEmail = autocompleteEmail;
        scope.remindPassword = remindPassword;
        scope.submit = submit;
        scope.signInWithGoogle = signInWithGoogle;

        // Initial defaults based on hostname (avoids flash on prod)
        scope.showSignInWithGoogle = shouldShowSignInWithGoogle() || 'localhost' === $window.location.hostname;
        scope.showEmailAndPassword = shouldShowEmailAndPassword() || 'localhost' === $window.location.hostname;

        // Fetch environment from backend, then adjust visibility for non-prod
        RipServer
          .exec('/rip/login/json/getEnv')
          .then(function(data) {
            if ('production' !== data.environment) {
              scope.showSignInWithGoogle = true;
              scope.showEmailAndPassword = true;
            }
          });

        // Load script and initialize when directive is ready
        if (scope.showEmailAndPassword) {
          setTimeout(() => {
            if (scope.login.email) {
              $document[0].getElementById('rip-login-password')?.focus();
            } else {
              $document[0].getElementById('rip-login-email')?.focus();
            }
          }, 100);
        }

        // Always set up listener — harmless if button isn't shown
        $window.addEventListener('message', handlePopupMessage);
        scope.$on('$destroy', function() {
          $window.removeEventListener('message', handlePopupMessage);
        });

        // trigger center position after the image is loaded
        angular.element($document[0].getElementById('rip-login-logo')).bind('load', function() {
          scope.$apply(angular.noop);
        });

        function autocompleteEmail() {
          if (scope.login.email && -1 === scope.login.email.indexOf('@')) {
            scope.login.email = scope.login.email.trim() + '@matchcraft.com';
          }
        }

        function validate() {
          scope.error = {};

          if (!scope.login.email) {
            scope.error.email = i18n('Field is required');
            return false;
          }

          return true;
        }

        function remindPassword() {
          if (!validate()) return;

          RipServer
            .exec('/rip/login/json/remindPassword?cachebust=' + new Date().getTime(),
                  { email: scope.login.email,
                    urlLocaleCode: RipRoute.getParam('localeCode') })
            .then(function(success) {
              RipDialog.message({ title: i18n('Note'),
                                  template: require('views/rip-dialog-info.html'),
                                  bindings: { message: i18n('A reminder email was sent to {0}.', scope.login.email) }
                                });
            }, handleFailure);
        }

        function submit() {
          if (!validate()) return;

          var login = scope.login;

          autocompleteEmail();

          RipServer
            .exec('/rip/login/json/authenticate',
                  { email : login.email,
                    password: login.password,
                    urlLocaleCode: RipRoute.getParam('localeCode') })
            .then(function(response) {
              if (response?.requiresRedirect) {
                $window.location.href = response.redirectUrl;
                return;
              }
              posthog.capture('LOGIN', {
                success: true
              });

              if (login.rememberEmail) {
                $cookies.put('loginEmail',
                             login.email,
                             { path: '/',
                               secure: true,
                               expires: new Date(new Date().getTime()
                                                 + (365 * 24 * 60 * 60 * 1000)) });
              } else {
                $cookies.remove('loginEmail');
              }

              posthog.reset(true);

              $window.location.reload();

            }, handleFailure);
        }

        function signInWithGoogle() {
          var popupWidth = 500;
          var popupHeight = 600;
          var left = $window.screenX + ($window.outerWidth - popupWidth) / 2;
          var top = $window.screenY + ($window.outerHeight - popupHeight) / 2;

          var popup = $window.open(
            '/rip/login/signInWithGoogle',
            'googleSignIn',
            'width=' + popupWidth + ',height=' + popupHeight +
            ',left=' + left + ',top=' + top +
            ',scrollbars=yes,resizable=yes,status=yes,location=yes,toolbar=no,menubar=no'
          );

          // Check if popup was blocked
          if (!popup || popup.closed || 'undefined' === typeof popup.closed ) {
            scope.error.message = 'Popup was blocked. Please allow popups for this site and try again.';
            scope.$apply();
            return;
          }
        }

        function handlePopupMessage(event) {
          // Verify the message is from our popup and contains the expected data
          if (event.data && 'googleSignInSuccess' === event.data.type) {
            $window.location.reload();
          }
        }

        function handleFailure(failure) {
          if (failure && failure.message) {
            scope.error.message = failure.message;

            posthog.capture('LOGIN', {
              failure: failure.message
            });
          }

          var emailElement = $document[0].getElementById('rip-login-email');
          emailElement.focus();
          emailElement.select();
        }

        function shouldShowSignInWithGoogle() {
          return 'superusers.advertiserreports.com' === $window.location.hostname;
        }

        function shouldShowEmailAndPassword() {
          return !shouldShowSignInWithGoogle();
        }
      }
    };
  });
